import React from 'react';
import svg from '../../assets/img/blob-haikei.svg';
const About = () => {
    return (
        <div className='flex flex-col items-center justify-center  md:max-w-[50%] max-w-[90%] mx-auto'>
            <img className='w-96' src={svg} alt="" />
            <div className='pb-6 text-center'>
                <h1 className='text-4xl p-4'>hyy!! I'm Hasan Uddin Rimon.</h1>
                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Vel eligendi quae libero voluptate accusamus sequi natus voluptatibus harum sapiente voluptas aliquam delectus laborum, in adipisci aspernatur sint vitae praesentium labore?</p>
            </div>
        </div>
    );
};

export default About;